<template>
    <div v-if='value' class='w-100 mb-1 mt-1'>
        <template v-if='editable'>
            <div class='d-flex flex-row align-items-center'>
                <input :placeholder="this.$t('translations.systolic')" size='8' class='form-control form-control-sm w-auto mr-1' type="text" v-model='value.systolic'>
                &nbsp;/&nbsp;
                <input :placeholder="this.$t('translations.diastolic')" size='8' class='form-control form-control-sm w-auto mr-1' type="text" v-model='value.diastolic'>
                <textarea v-if='showdescription' @focus="show_characters_left = true" @blur="show_characters_left = false" rows='1' v-autosize="value.descriptive_text" :placeholder="this.$t('translations.description')" style='width:100%' class='form-control form-control-sm mr-1' type='text' v-model='value.descriptive_text' />
            </div>
            
            <div class='d-flex flex-row align-items-center'>
                <p v-if='show_characters_left' class='h6 text-nowrap chars-left mb-0 mt-2 mr-1 ml-1'  aria-live="polite">{{ charactersLeft }}</p>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    props: {
        value: {
        },
        editable: {
            default: true,
        },
        showdescription: {
            default: true,
        }
    },
    data() {
        return {
            resetCounter: 0,
            show_characters_left: false,
        };
    },
    computed: {
        charactersLeft() {
            if(typeof this.value.descriptive_text === 'string') {
                var char = this.value.descriptive_text.length;
                var limit = 1024;

                if(char > limit) {
                    this.value.descriptive_text = this.value.descriptive_text.substr(0, limit);
                    char = this.value.descriptive_text.length;
                }
                return (limit - char) + " " + this.$t('translations.characters_remaining');
            }
            return "";
        },
    },
    watch: {
        
    },
    mounted() {
        //console.info(this.value);
        if(!this.value.systolic) {
            Vue.set(this.value, 'systolic', '');
            Vue.set(this.value, 'diastolic', '');
            Vue.set(this.value, 'descriptive_text', '');
        }
    },
    methods: {
        clear() {
            this.value.systolic = "";
            this.value.diastolic = "";
            this.value.descriptive_text = "";
        },
        reset() {
            // So annoying. If you enter a partial date, then the code has no way to know that that
            // is being displayed in the UI. So we force new components to refresh.
            this.resetCounter++;
        },
    },
};
</script>

<style scoped>
    .btn-clear {
        width: 22px; 
        height: 22px; 
        font-size: 13px; 
        padding: 0px;
        border: 1px solid #a0a0a0;
        border-radius: 0.25rem;
        font-weight: bold;
        color: rgb(120, 130, 140);
    }
</style>